/**
 * Stub for OfferingsServiceApiClient.
 * In supersonic-ui this fetches filter options from the offerings API.
 * Stubbed here — returns null so dynamic choice variants render with
 * their static options only.
 */
export const getFilters = async (_params: {
  type?: string;
  subject?: string;
}): Promise<null> => {
  return null;
};
